const standardWatchDownlinkList = [
  'lrh980805@sina.com',
  'liuruihan@muhuakeji.com',
  'admin@bonuscloud.io',
  '277233980@qq.com',
  'wangzhen6862@qq.com',
  'wangzhen6867@qq.com',
  '13728916860@qq.com',
  'wangzhen6870@qq.com',
  'wangzhen6868@qq.com',
  'wangzhen6860@qq.com',
  'huichen02@126.com',
  '547431098@qq.com',
  'huichen01@126.com',
  '251067899@qq.com',
  'china@shoukuan.ren',
  'ylrx@shoukuan.ren',
  'bank@shoukuan.ren',
];

export { standardWatchDownlinkList };
